import { LABEL_PLACEHOLDERS, type LabelType } from '../../../utils/labelPlaceholders.ts';

export const PlaceholderHelp = ({ labelType }: { labelType: LabelType }) => (
  <div>
    Mögliche Variablen:
    {LABEL_PLACEHOLDERS[labelType].map(p => (
      <div key={p.key}>
        %{p.key}% - {p.description}
      </div>
    ))}
  </div>
);
